import { BookServiceService } from './../../services/book-service.service';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-dash-board',
  templateUrl: './dash-board.component.html',
  styleUrls: ['./dash-board.component.scss']
})
export class DashBoardComponent implements OnInit {


  constructor( ) { }
   openNav() {  document.getElementById("mySidenav").style.width = "250px";

  }
  
   closeNav() {
    document.getElementById("mySidenav").style.width = "0";

    document.body.style.backgroundColor = "white";
  }
 
  ngOnInit() {   
  }
  bookTitle ="";


  onOpen(event: any) {
    console.log('done');
  }
ea(id:any){
  console.log('doe');
  
}

}
